import request from "@/utils/request";

//手机号密码登录
export function login(data) {
  return request({
    url: "/client/login/phoneAndPassword",
    method: "post",
    data: data,
  });
}